// extracted by mini-css-extract-plugin
module.exports = {"headingNews":"News_headingNews__3fpgh","dateNews":"News_dateNews__2Jp1M","titleNews":"News_titleNews__3fQLQ","textNews":"News_textNews__eyrue"};